// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xml:space='preserve'
    width='800'
    height='800'
    viewBox='0 0 92.732 92.731'
    ...attributes
  ><path
      d='M1.134 0h90.463v7H1.134zM1.186 25.721h90.357v7H1.186zM1.134 52.795h90.463v7H1.134zM1.186 78.518h90.357v7H1.186z'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'FourLines';
export default IconComponent;
